import cookie from '@s-ui/js/lib/cookie'
import {getDecision} from '@s-ui/pde'

const HAS_SERVER_ERROR = {hasServerError: true}

export const getInitialProps = async ({routeInfo, context: {cookies, i18n, domain, pde}}) => {
  const {culture} = i18n
  const config = domain.get('config')
  const {
    params,
    location: {
      pathname: path,
      query: {q: searchTerm, pg = 1},
      search
    }
  } = routeInfo

  const _getSection = ({pageName}) => {
    const {TIPS: tipsSection, TRENDS: trendsSection} = config.get('COMMON').NEWS_SECTIONS

    const {NEWS_SECTION_TIPS_PAGE_NAME, NEWS_SECTION_TRENDS_PAGE_NAME} = config.get('page')

    switch (pageName) {
      case NEWS_SECTION_TIPS_PAGE_NAME:
        return tipsSection
      case NEWS_SECTION_TRENDS_PAGE_NAME:
        return trendsSection
      default:
        break
    }
  }

  const route = `${path}${search}`
  const page = Number(pg)
  const {category, tag} = params
  const term = tag || searchTerm

  const {pageName} = await domain.get('get_page_name_page_use_case').execute({path: route})

  const {decide} = getDecision(pde)
  const {enabled: isNewsBookmarksEnabled} = decide('ff_web_growth_news_bookmarks', {queryString: search})

  const _getSavedNewsIds = () =>
    isNewsBookmarksEnabled ? domain.get('get_saved_news_ids_use_case').execute() : Promise.resolve([null, []])

  const section = _getSection({pageName})

  // News feed is the page's reason for being — any failure (HTTP 4xx/5xx,
  // network, abort, …) renders the server-error message rather than letting
  // the page through with newsFeed: undefined.
  let newsFeed
  try {
    newsFeed = await domain.get('news_search_feed_use_case').execute({tag, searchTerm, category, page, section})
  } catch {
    return HAS_SERVER_ERROR
  }

  const {count: nResults} = newsFeed ?? {}

  // Tagcloud is decorative — never let its failure (e.g. 403) tank the page.
  const tagcloudsPromise = domain
    .get('get_tagcloud_seo_use_case')
    .execute({pageName, tag, searchTerm})
    .catch(() => [])

  let initialPageData
  try {
    const [[, {head: helmet, h1} = {}] = [], [, breadcrumb] = [], tagclouds] = await Promise.all([
      domain.get('get_seo_data_use_case').execute({culture, pageName, params: {term, category, page, nResults}}),
      domain.get('get_breadcrumbs_breadcrumb_use_case').execute({pageName, params: {term, category}}),
      tagcloudsPromise
    ])
    initialPageData = {
      breadcrumb,
      category,
      h1,
      helmet,
      page,
      pageName,
      searchTerm,
      section,
      tagclouds,
      term
    }
  } catch {
    return HAS_SERVER_ERROR
  }

  const [savedNewsIdsError, savedNewsIdsResponse] = await _getSavedNewsIds().catch(() => [null, []])
  const savedArticleIds = !savedNewsIdsError && savedNewsIdsResponse ? savedNewsIdsResponse : []

  const {HAS_VISITED_SAVED_NEWS_TAB} = config.get('COMMON').COOKIES
  const hasVisitedSavedNewsTab = Boolean(
    typeof window !== 'undefined'
      ? cookie.get(HAS_VISITED_SAVED_NEWS_TAB)
      : cookie.parse(cookies)[HAS_VISITED_SAVED_NEWS_TAB]
  )

  return {
    hasVisitedSavedNewsTab,
    isNewsBookmarksEnabled,
    newsFeed,
    initialPageData,
    savedArticleIds
  }
}
